import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={32}
    height={32}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:none;stroke:#a3d8e7;stroke-miterlimit:10}"}</style>
    </defs>
    <g id="Palette">
      <path
        d="m23.51 2.83 5.66 5.66L8.49 29.17l-5.66-5.66L23.51 2.83m0-2.83L0 23.51 8.49 32 32 8.49 23.51 0Z"
        style={{
          fill: "#a3d8e7",
          strokeWidth: 0,
        }}
      />
      <path
        d="m14.59 8.93 4.24 4.24M17.41 6.1l4.25 4.24M20.24 3.27l4.25 4.24M8.93 14.59l4.24 4.24M11.76 11.76 16 16M3.27 20.24l4.24 4.25M6.1 17.41l4.24 4.25"
        className="cls-1"
      />
    </g>
  </svg>
)
export default SvgComponent